import { render, staticRenderFns } from "./SimSolicitudesPantalla.vue?vue&type=template&id=2f1bbd48&"
import script from "./SimSolicitudesPantalla.vue?vue&type=script&lang=ts&"
export * from "./SimSolicitudesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f1bbd48', component.options)
    } else {
      api.reload('2f1bbd48', component.options)
    }
    module.hot.accept("./SimSolicitudesPantalla.vue?vue&type=template&id=2f1bbd48&", function () {
      api.rerender('2f1bbd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SIMSolicitudes/SimSolicitudesPantalla.vue"
export default component.exports